import { IOfferScopeCapTypeLang } from '../../../types/lang'
import { EOfferScopeCapType } from '../../../types'

export const offerScopeCapTypeLang: IOfferScopeCapTypeLang = {
	offer_scope_cap_type: {
		[EOfferScopeCapType.cumulative]: 'cumulative_ua',
		[EOfferScopeCapType.daily]: 'daily_ua',
	}
}